import { GenexSISModel } from "@/models/sis/GenexSISModel";
import {Model} from "@vuex-orm/core";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";

export default class Activity extends Model {
  static entity = "activity";

  static fields() {
    return {
      id: this.attr(null),
      note: this.attr(""),
      created_at: this.attr(null),
    };
  }
}
